import { Maybe } from '@varo/graphql-schema-types';
import React, { ReactNode } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import {
  PressableAnalyticsProps,
  usePressableAnalytics,
} from 'shared/hooks/analytics/usePressableAnalytics';

export interface SVGButtonProps extends PressableAnalyticsProps {
  onPress: Maybe<() => void>;
  SVGComponent: ReactNode;
  testID?: string;
}

const SVGButton = ({
  SVGComponent,
  analyticsId = '',
  customAttributes = null,
  onPress,
  testID,
}: SVGButtonProps) => {
  const buttonAnalytics = usePressableAnalytics({
    analyticsId,
    customAttributes,
  });

  return (
    <Pressable
      onPress={() => {
        buttonAnalytics?.();
        onPress?.();
      }}
      style={({ pressed }) => [pressed && styles.pressedState]}
      testID={testID}
    >
      {SVGComponent}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  pressedState: {
    opacity: 2,
    transform: [{ scale: 0.95 }],
  },
});

export default SVGButton;
